module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand2-ddac32fe332817d11032f71d84218efe.jpg";